import React from 'react';

// tone: navy | lime | success | danger | warning | neutral
export function Badge({ tone = 'navy', icon: Icon, className = '', children }) {
  return (
    <span className={`ss-badge ss-badge--${tone} ${className}`}>
      {Icon && <Icon size={13} strokeWidth={2.4} aria-hidden="true" />}
      {children}
    </span>
  );
}

// Tag de tipo de conteúdo no estilo <Aula/>.
export function CodeTag({ children, className = '' }) {
  return (
    <span className={`ss-codetag ${className}`}>
      <span className="ss-codetag__br">&lt;</span>
      {children}
      <span className="ss-codetag__br">/&gt;</span>
    </span>
  );
}

// "03 | FORMATO": número em verde e rótulo espaçado.
export function SectionTag({ num, label, className = '' }) {
  return (
    <span className={`ss-sectiontag ${className}`}>
      {num != null && <span className="ss-sectiontag__num">{String(num).padStart(2, '0')}</span>}
      {num != null && <span className="ss-sectiontag__sep" aria-hidden="true" />}
      <span className="ss-sectiontag__label">{label}</span>
    </span>
  );
}

// Chip selecionável para filtros.
export function Chip({ active = false, color, onClick, children, count }) {
  return (
    <button
      type="button"
      className={`ss-chip ${active ? 'ss-chip--active' : ''}`}
      onClick={onClick}
      aria-pressed={active}
    >
      {color && <span className="ss-chip__dot" style={{ background: color }} />}
      <span>{children}</span>
      {count != null && <span className="ss-chip__count">{count}</span>}
    </button>
  );
}
